module.exports = __webpack_public_path__ + "static/okoy-2f6190de95d54531cfff424597350214.jpg";